import { Sparkles } from "@medusajs/icons"
import type { CartPromotionPresentation } from "../../types"
import styles from "./cart-bundle-incentive.module.css"

export default function CartBundleIncentive({
  incentive,
}: {
  incentive: CartPromotionPresentation["incentive"]
}) {
  if (!incentive) return null

  return (
    <section className={styles.root} data-testid="cart-bundle-incentive">
      <Sparkles aria-hidden="true" />
      <p className={styles.message}>
        {incentive.additional_quantity === 1 ? "Bir" : incentive.additional_quantity} ürün daha ekleyin, {incentive.free_quantity} tanesi ücretsiz olsun
      </p>
    </section>
  )
}
